<!--
  ReportView.vue — the interactive report viewer route (/reports/:id).
  Purpose: a thin host for the report engine's self-contained screen. The reports
  engine ships ReportViewScreen (src/reports/ReportViewScreen.vue), which registers
  the `report-view` module in beforeCreate, globally registers the section renderers
  (table / text / xy_graph + report-section-not-found fallback), watches
  $route.params.id (immediate) and dispatches `report-view/fetch(report_id)` →
  request('report/tracker/retrieve', {report_id}, 'report'). This view just mounts it.
  Reconstructed from lacak.io deployed behavior; app-specific contract verbatim
  (route /reports/:id, module `report-view`, section2cmp registry — HISTORY-REPORTS
  §1a/§2), internal impl re-authored.
-->
<template>
  <v-container fluid>
    <report-view-screen></report-view-screen>
  </v-container>
</template>

<script>
import ReportViewScreen from '@/reports/ReportViewScreen.vue'

export default {
  name: 'ReportView',
  components: {
    'report-view-screen': ReportViewScreen
  }
}
</script>
